import 'select2';
import Pagination from '../modules/pagination/pagination';

class PresentationSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.selects = this.root.querySelectorAll('select');
        this.paginationWrapper = this.root.querySelector('.pagination');
        this.loaderWrapper = this.root.querySelector(
            '.investor-presentations__loader-wrapper'
        );
        this.htmlWrapper = this.root.querySelector(
            '.investor-presentations__list-wrapper'
        );

        this.selectInstances = [];
        this.paginationInstance = null;

        this.page = 1;
        this.perPage = parseInt(this.root.getAttribute('data-per-page'));
        this.sortBy = 'desc';
        this.year = '';
        this.period = '';

        return true;
    }

    init() {
        this.handleSelectInstances();
        this.handleSelectListener();
        this.handlePaginationInstance();
    }

    handleSelectInstances() {
        if (this.selects.length === 0) return false;

        this.selects.forEach(select => {
            const settings = JSON.parse(select.getAttribute('data-settings'));
            settings['width'] = '100%';
            settings['dropdownCssClass'] = 'no-search';
            this.selectInstances.push($(select).select2(settings));
        });
    }

    handleSelectListener() {
        if (this.selectInstances.length === 0) return false;
        const that = this;
        this.selectInstances.forEach(instance => {
            instance.on('select2:select', function (e) {
                const selectedIndex = this.selectedIndex;
                const val = this.options[selectedIndex].value;
                if (this.getAttribute('name') === 'years-select') {
                    that.year = selectedIndex === 1 ? '' : val;
                } else if (this.getAttribute('name') === 'period-select') {
                    that.period = selectedIndex === 1 ? '' : val;
                } else {
                    that.sortBy = val;
                }
                that.page = 1;
                that.handleFetch();
            });
        });
    }

    handlePaginationInstance() {
        if (!this.paginationWrapper) return false;

        this.paginationInstance = new Pagination(
            this.paginationWrapper,
            this.root
        );

        this.root.addEventListener('pagination-change', e => {
            const { detail } = e;
            this.page = detail;
            this.handleFetch();
        });
    }

    async handleFetch() {
        this.loaderWrapper.classList.add('active');
        try {
            const formData = new FormData();

            formData.append('action', 'handle_presentation_fetch');
            formData.append('page', this.page);
            formData.append('posts_per_page', this.perPage);
            formData.append('year', this.year);
            formData.append('period', this.period);
            formData.append('sortBy', this.sortBy);

            console.log(this.year, this.period, this.sortBy);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            if (!req) return;

            const { html, page, max_num_pages } = await req.json();

            if (html?.length > 0) {
                this.htmlWrapper.innerHTML = html;
                this.paginationInstance.reset(page, parseInt(max_num_pages));
            }
        } catch (error) {
            console.log(erorr);
        } finally {
            this.htmlWrapper.scrollIntoView();
            this.loaderWrapper.classList.remove('active');
        }
    }
}

const sections = document.querySelectorAll('.investor-presentations');
const initReportsSections = sections => {
    if (sections) {
        sections.forEach(section => new PresentationSection(section));
    }
};

initReportsSections(sections);
